const achievements = {
    "name": "Achievement",
    "data": [
        {
            "name": "Net Challenge",
            "result": "First Prize",
            "yearDate": "2020",
            "organizer": "University",
            "description": "A CCNA networking competition",
            "image": "https://personal-portfolio-khangtictoc.s3.us-east-1.amazonaws.com/asset/img/certificate/net-challenge.png"
        },
        {
            "name": "Azure-104",
            "result": "Certified",
            "yearDate": "2022",
            "organizer": "Microsoft",
            "description": "Azure Administrator Associate",
            "image": "https://personal-portfolio-khangtictoc.s3.us-east-1.amazonaws.com/asset/img/certificate/azure104.png"
        },
        {
            "name": "AWS SAA-C03",
            "result": "Certified",
            "yearDate": "2025",
            "organizer": "Amazon",
            "description": "AWS Certified Solutions Architect – Associate",
            "image": "https://personal-portfolio-khangtictoc.s3.us-east-1.amazonaws.com/asset/img/certificate/aws-saa-c03.png"
        },
        {
            "name": "CKA",
            "result": "Certified",
            "yearDate": "2025",
            "organizer": "Linux Foundation",
            "description": "Certified Kubernetes Administrator",
            "image": "https://personal-portfolio-khangtictoc.s3.us-east-1.amazonaws.com/asset/img/certificate/cka.png"
        },
        {
            "name": "CKAD",
            "result": "Certified",
            "yearDate": "2025",
            "organizer": "Linux Foundation",
            "description": "Certified Kubernetes Administrator",
            "image": "https://personal-portfolio-khangtictoc.s3.us-east-1.amazonaws.com/asset/img/certificate/ckad.png"
        },
        {
            "name": "CKS",
            "result": "Certified",
            "yearDate": "2025",
            "organizer": "Linux Foundation",
            "description": "Certified Kubernetes Security Administrator",
            "image": "https://personal-portfolio-khangtictoc.s3.us-east-1.amazonaws.com/asset/img/certificate/cks.png"
        },
        {
            "name": "KCNA",
            "result": "Certified",
            "yearDate": "2026",
            "organizer": "Amazon",
            "description": "Kubernetes and Cloud Native Associate",
            "image": "https://personal-portfolio-khangtictoc.s3.us-east-1.amazonaws.com/asset/img/certificate/kcna.png"
        },
        {
            "name": "KCSA",
            "result": "Certified",
            "yearDate": "2026",
            "organizer": "Linux Foundation",
            "description": "Kubernetes and Cloud Native Security Associate",
            "image": "https://personal-portfolio-khangtictoc.s3.us-east-1.amazonaws.com/asset/img/certificate/kcsa.png"
        },
        {
            "name": "Kubestronaut",
            "result": "Certified",
            "yearDate": "2026",
            "organizer": "Linux Foundation",
            "description": "Complete All Kubernetes Exam",
            "image": "https://personal-portfolio-khangtictoc.s3.us-east-1.amazonaws.com/asset/img/certificate/kubestronaut.png"
        }
    ]
}

export default achievements;